// extracted by mini-css-extract-plugin
export default {"author-card":"AuthorCard_author-card__I0I5K","title":"AuthorCard_title__xCPsy","link":"AuthorCard_link__klJJt","description":"AuthorCard_description__XJpwX"};